import QueryEmployeeEros from 'graphql/queries/QueryEmployeeEros'
import GraphqlGroupedBuilder from 'utils/request/graphql/groupedBuilder'

const FetchEmployeeEro = {
	
	fetchAll: ( { variables = {}, callbackSuccess = null, callbackError = null, callbackStart = null } = {} ) => {
		GraphqlGroupedBuilder.addQuery( 'employees_ero', QueryEmployeeEros, {
			variables,
			resultPath: [ 'employees_ero' ],
			callbackStart,
			callbackError,
			callbackSuccess
		})
	}
}

export default FetchEmployeeEro
